import { IInitialStateProps } from 'context/registerContext';
import {
  allIsFalse,
  DEFAULT_VALID,
  requiredIsValid,
  ValidationModel,
} from 'helpers/utils/ValidationUtils';

export type SurveyValidatorType = {
  templateIsValid: () => ValidationModel;
  allIsValid: () => boolean;
};

export const SurveyValidation = (
  state: IInitialStateProps,
  enabled: boolean
) => {
  const validator: Partial<SurveyValidatorType> = {};

  validator.templateIsValid = () => {
    const value = state.survey.template;
    const required = requiredIsValid(value, 'Template é obrigatório');

    if (!enabled) {
      return DEFAULT_VALID;
    } else {
      if (required.error) {
        return required;
      }
      return DEFAULT_VALID;
    }
  };

  validator.allIsValid = () => {
    return allIsFalse([validator?.templateIsValid!().error]);
  };

  return validator as SurveyValidatorType;
};
